var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-none",style:({ height: '40px' }),attrs:{"color":"primary"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" Filters "),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-tune")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }